import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Selection } from '../../../selection/models';

@Component({
    selector: 'app-single-selection-control',
    templateUrl: './single-selection-control.component.html',
    styleUrls: ['./single-selection-control.component.scss'],
    standalone: false
})
export class SingleSelectionControlComponent {
    @Input() formGroup: UntypedFormGroup | undefined;
    @Input() selections: Selection[] = [];
    @Input() control: AbstractControl | null | undefined;
    @Input() formControlName: string | undefined;
    @Input() header: string | undefined;
    @Input() label: string | undefined;
    @Input() requiredMessage: string | undefined;
    @Input() formSubmitted: boolean | undefined;
    @Input() requiredFormControlName: string | undefined;

    updateRadioGroup(event: MatRadioChange) {
        if (!this.formControlName || !this.control || !this.formGroup)
            throw new Error('`formControlName` input must be provided');

        this.control.setValue(event.source.value);

        const control = this.formGroup.get(this.formControlName);
        control?.setValue(this.control.value);
        this.control.markAsTouched();
    }

    get isRequired(): boolean {
        if (!this.formGroup && !this.requiredFormControlName) return false;

        if (this.requiredFormControlName) {
            return (
                this.formGroup?.hasError(this.requiredFormControlName) ?? false
            );
        }

        return this.control?.hasError('required') ?? false;
    }
}
